module.exports = __webpack_public_path__ + "img/kuaishou.154f0448.png";